import React from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ApplicationsLayer from "../components/ApplicationsLayer";
import { useApplicationContext } from "../context/ApplicationContext";
import { applicationTabs } from "../helper/applicationTabs";

const ApplicationsPage = () => {
  const { tabId } = useParams();
  const { activeTabId } = useApplicationContext();

  const currentTabId = tabId || activeTabId;
  const currentTab = applicationTabs.find(t => t.id === currentTabId);
  const title = currentTab ? currentTab.title : "Applications";

  return (
    <>
      <MasterLayout>
        <Breadcrumb title={title} />
        <ApplicationsLayer />
      </MasterLayout>
    </>
  );
};

export default ApplicationsPage;
